import apiClient from "config/api";

const login = async (payload) => {
  return apiClient.post("/admin/auth/login", payload);
};

const checkEmail = async (email) => {
  return await apiClient.post(`/admin/auth/${email}`);
};

export { login, checkEmail };
